module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tl-c7a146dc0d916983f8dd11f2982c0ed9.svg";